<div class="login">
  <div class="container">
    <div class="d-flex justify-content-center pt-5">
      <div class="col-5 p-4">
        <img
          class="logo mx-auto d-block pb-5"
          src="assets/images/logo-white.png" />
        <div class="login-div text-center">
          <form
            [formGroup]="form"
            role="form"
            autocomplete="off"
            novalidate
            (keydown.enter)="form.valid ? onLogin() : null">
            <fieldset [disabled]="loading">
              <div class="input-group mb-3">
                <span class="input-group-text">
                  <img src="assets/icons/mdi_account-outline.svg" />
                </span>
                <div class="form-floating">
                  <input
                    type="text"
                    class="form-control bg-transparent border-0"
                    id="username"
                    formControlName="username"
                    placeholder="{{ 'common.username' | translate }}"
                    autocomplete="new-username" />
                  <label
                    for="username"
                    class="form-label bg-transparent">
                    {{ 'common.username' | translate }}
                  </label>
                </div>
              </div>
              <div
                *ngIf="action === 'login'"
                class="input-group mb-3">
                <span class="input-group-text">
                  <img src="assets/icons/mdi_lock-outline.svg" />
                </span>
                <div class="form-floating">
                  <input
                    [type]="showNewPassword ? 'text' : 'password'"
                    class="form-control bg-transparent border-0"
                    id="password"
                    formControlName="password"
                    placeholder="{{ 'common.password' | translate }}"
                    autocomplete="new-password" />
                  <label
                    for="password"
                    class="form-label bg-transparent">
                    {{ 'common.password' | translate }}
                  </label>
                </div>
                <span class="input-group-text">
                  <app-button
                    classes="text-primary"
                    (clicked)="onShowPassword()">
                    <img [src]="!showNewPassword ? 'assets/icons/mdi_eye.svg' : 'assets/icons/mdi_eye-off.svg'" />
                  </app-button>
                </span>
              </div>
            </fieldset>
          </form>
          <app-button
            *ngIf="action === 'login'"
            classes="mt-4 w-100 btn-primary btn-spinner-light"
            [showSpinner]="loading"
            [disabled]="form.invalid"
            (clicked)="onLogin()">
            {{ 'login.login' | translate }}
          </app-button>
          <app-button
            *ngIf="action === 'recovery'"
            classes="mt-4 w-100 btn-primary btn-spinner-light"
            [showSpinner]="loading"
            [disabled]="!form.get('username')!.valid"
            (clicked)="onRecovery()">
            {{ 'login.recoverPassword' | translate }}
          </app-button>
          <div class="pt-3">
            <a
              class="link-secondary"
              (click)="toggleAction()">
              <ng-container *ngIf="action === 'login'">
                {{ 'login.forgotPassword' | translate }}
              </ng-container>
              <ng-container *ngIf="action === 'recovery'">
                {{ 'login.backToLogin' | translate }}
              </ng-container>
            </a>
          </div>
        </div>
      </div>
        </div>
    <div class="text-center p-3 policy">
  <a routerLink="/privacy-policy" href="/privacy-policy">
    {{ 'privacyPolicy.privacyPolicy' | translate }}
  </a>
</div>
    </div>
</div>
